import { useEffect } from "react";

const SEO = ({
  title = "Baby Zoo Garden - Art&Fun Club | Kreativne radionice za djecu Zagreb",
  description = "Art&Fun Club nudi slikarske radionice, facepainting, kreativne radionice i animacije za djecu u Zagrebu. Profesionalne art terapeutske aktivnosti i rođendanske proslave.",
  keywords = "kreativne radionice za djecu, facepainting Zagreb, slikarske radionice Zagreb, animacije za djecu, rođendani Zagreb, art terapija djeca, Baby Zoo Garden, Art&Fun Club",
  image = "https://babyzoogarden.com/assets/img/og-image.jpg",
  url = "https://babyzoogarden.com",
  type = "website",
}) => {
  useEffect(() => {
    // Set page title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? "property" : "name";
      let element = document.querySelector(`meta[${attribute}="${name}"]`);

      if (element) {
        element.setAttribute("content", content);
      } else {
        element = document.createElement("meta");
        element.setAttribute(attribute, name);
        element.setAttribute("content", content);
        document.head.appendChild(element);
      }
    };

    // Basic meta tags
    updateMetaTag("description", description);
    updateMetaTag("keywords", keywords);

    // Open Graph
    updateMetaTag("og:type", type, true);
    updateMetaTag("og:url", url, true);
    updateMetaTag("og:title", title, true);
    updateMetaTag("og:description", description, true);
    updateMetaTag("og:image", image, true);
    updateMetaTag("og:image:width", "1200", true);
    updateMetaTag("og:image:height", "630", true);
    updateMetaTag("og:locale", "hr_HR", true);
    updateMetaTag("og:site_name", "Baby Zoo Garden", true);

    // Twitter Card
    updateMetaTag("twitter:card", "summary_large_image");
    updateMetaTag("twitter:url", url);
    updateMetaTag("twitter:title", title);
    updateMetaTag("twitter:description", description);
    updateMetaTag("twitter:image", image);

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", url);
    } else {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      canonical.setAttribute("href", url);
      document.head.appendChild(canonical);
    }

    // JSON-LD Structured Data
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "Baby Zoo Garden - Art&Fun Club",
      image: image,
      description: description,
      "@id": url,
      url: url,
      telephone: "+385993152678",
      email: "marina@babyzoogarden.com",
      address: {
        "@type": "PostalAddress",
        streetAddress: "",
        addressLocality: "Zagreb",
        postalCode: "",
        addressCountry: "HR",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: 45.815,
        longitude: 15.9819,
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "09:00",
        closes: "20:00",
      },
      priceRange: "$$",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "5",
        reviewCount: "47",
      },
      sameAs: [
        "https://www.facebook.com/babyzoogarden",
        "https://www.instagram.com/babyzoogarden",
      ],
    };

    const services = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: [
        {
          "@type": "Service",
          name: "Slikarske radionice",
          description: "Kreativne slikarske radionice za djecu svih uzrasta",
          provider: {
            "@type": "Organization",
            name: "Baby Zoo Garden",
          },
        },
        {
          "@type": "Service",
          name: "Facepainting",
          description: "Profesionalno šminkanje lica za djecu na proslavama",
          provider: {
            "@type": "Organization",
            name: "Baby Zoo Garden",
          },
        },
        {
          "@type": "Service",
          name: "Kreativne radionice",
          description: "Raznovrsne kreativne aktivnosti za djecu",
          provider: {
            "@type": "Organization",
            name: "Baby Zoo Garden",
          },
        },
        {
          "@type": "Service",
          name: "Kreativna animacija",
          description: "Animacije za dječje rođendane i proslave",
          provider: {
            "@type": "Organization",
            name: "Baby Zoo Garden",
          },
        },
      ],
    };

    // Add or update JSON-LD scripts
    let ldScript = document.querySelector(
      'script[type="application/ld+json"]#business-data'
    );
    if (!ldScript) {
      ldScript = document.createElement("script");
      ldScript.type = "application/ld+json";
      ldScript.id = "business-data";
      document.head.appendChild(ldScript);
    }
    ldScript.textContent = JSON.stringify(structuredData);

    let servicesScript = document.querySelector(
      'script[type="application/ld+json"]#services-data'
    );
    if (!servicesScript) {
      servicesScript = document.createElement("script");
      servicesScript.type = "application/ld+json";
      servicesScript.id = "services-data";
      document.head.appendChild(servicesScript);
    }
    servicesScript.textContent = JSON.stringify(services);
  }, [title, description, keywords, image, url, type]);

  return null;
};

export default SEO;
